<template>
        <div class="content">
            <div class="img">
                <img :src="player.image" :alt="player.name"/>
            </div>
            <div class="text">
                <h1>{{ player.name }}</h1>
                <input v-if="player.status" type="button" v-on:click="ClicPlayer" value="Suprimer du panier"/>
            </div>
            <div class="img">
                 <b v-text=player.price></b>M€
            </div>
        </div>
</template>

<script>
    export default {
        name: "CartItem",
        props:{
            player:Object,
        },
        methods: {
            ClicPlayer: function () {
                //On remonter les info par evenements
                this.$emit('cart-remove-player', this.player)
            }
        }
    }
</script>

<style scoped>
    .content{
        display: flex;
        flex-direction: row;
        border: 2px solid chartreuse;
        border-radius: 20px;
        padding: 6px;
        margin: 2px;
        max-height: 100px;
    }

    .img {
       /* background-color: red;*/
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
        max-height: 100%;
    }

    .text {
        flex: 3;
        /*background-color: aquamarine;*/
    }

    img {
        max-width: 100%;
        max-height: 100%;
    }
</style>